import axios from 'axios';

// Using global axios.defaults.baseURL set in index.jsx

class BannerService {
    // Get banners for specific location and section
    static async getBannersByLocationAndSection(location, section, userType = 'all') {
        try {
            const response = await axios.get(
                `/front/banners/location/${location}/section/${section}?targetAudience=${userType}`
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching banners:', error);
            throw error;
        }
    }

    // Get all active banners for a location
    static async getBannersByLocation(location, userType = 'all') {
        try {
            const response = await axios.get(
                `/front/banners/location/${location}?targetAudience=${userType}`
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching location banners:', error);
            throw error;
        }
    }

    // Track banner impression
    static async trackImpression(bannerId) {
        try {
            await axios.post(`/front/banners/${bannerId}/impression`);
            console.log('Banner impression tracked successfully for bannerId:', bannerId);
        } catch (error) {
            console.error('Error tracking impression:', error);
        }
    }

    // Track banner click
    static async trackClick(bannerId) {
        try {
            await axios.post(`/front/banners/${bannerId}/click`);
            console.log('Banner click tracked successfully for bannerId:', bannerId);
        } catch (error) {
            console.error('Error tracking click:', error);
        }
    }
}

export default BannerService;
